import _ from 'underscore';
import $ from 'jquery';
import Util from 'root/module/util';
import UI from 'root/ui';
import Router from 'root/router';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';
import View_Project_Overview from 'view/project/overview';
import { createProject } from 'view/project/create_project';

export default View.extend({
    tagName: 'section',

    search_value: '',

    views: {
        project_overview: {}
    },

    project_type: 'active', // active, feedback, survey, archived

    events: {
        'click .create-project'                : 'createProject',
        'click .project-menu'                  : 'onChooseProjectType',
        'click .project-sort-by'               : 'onChangeProjectSortBy',
        'click .project-sort-order'            : 'onChangeProjectSortOrder',
        'click .project-group-by'              : 'onChangeProjectGroupBy',
        'click .project-search-launcher'       : 'onToggleProjectSearch',
        'input .project-search-launcher input' : 'onSearchProject',
        'click .region-domain'                 : 'onToggleDomainGroup',
        'click .onboarding-assistant .close'   : 'onCloseOnboardingAssistant',
        'click .account-upgrade'               : 'onAccountUpgrade'
    },

    dom_handlers: {
        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        },

        createProject: function(e) {
            e.preventDefault();

            this.$el.find('.project-list').toggle();

            if (Cache.account.get('is_expired')) {
                Modals.expiredAccount();
                return;
            }

            if (Cache.account.getProjectLimit() <= Cache.project.where({is_archived: false}).length) {
                Modals.unlockFeature('To have more projects in your account, please upgrade your account plan.');
            } else {
                Modals.openTemplateGallery('', (template_code, template) => {
                    var project_name = template && template.template_name || 'My project';
                    createProject(project_name, [], template_code);
                }, {
                    close_on_success: false,
                    show_loader_on_select: true
                });
            }
        },

        onChooseProjectType: function(e) {
            this.project_type = $(e.currentTarget).data('val');

            this.$el.find('.project-menu').removeClass('active');
            this.$el.find('.project-menu[data-val="' + this.project_type + '"]').addClass('active');
            this.$el.find('.archived-delete-banner').toggle(this.project_type === 'archived');

            if (this.project_type === 'active') {
                Router.removeQueryString('t');
            } else {
                Router.addQueryString('t', this.project_type);
            }

            this.sortProjects();
            this.searchProjects();
        },

        onChangeProjectSortBy: function(e) {
            Cache.project.sort_by = $(e.currentTarget).data('val');
            this.renderSortBy();
            this.sortProjects();

            Cache.app.addUserSetting('project_sort_by', Cache.project.sort_by, false);
        },

        onChangeProjectSortOrder: function(e) {
            Cache.project.sort_order = $(e.currentTarget).data('val');
            this.renderSortBy();
            this.sortProjects();

            Cache.app.addUserSetting('project_sort_order', Cache.project.sort_order, false);
        },

        onChangeProjectGroupBy: function(e) {
            Cache.project.group_by = Cache.project.group_by === 'domain' ? 'none' : 'domain';
            this.render();

            Cache.app.addUserSetting('project_group_by', Cache.project.group_by, false);
        },

        onToggleProjectSearch: function(e) {
            this.$el.find('.project-search-launcher').addClass('active');
        },

        onSearchProject: function(e) {
            this.search_value = $(e.currentTarget).val().toLowerCase().trim();
            this.searchProjects();
        },

        onToggleDomainGroup: function(e) {
            // ignore clicks on the project overview
            if (!$(e.target).hasClass('region-domain')) {
                return;
            }

            $(e.currentTarget).toggleClass('active');
        },

        onDocumentClick: function(e) {
            if (this.search_value) {
                return;
            }

            if ($(e.target).parents('.project-search-launcher').length ) {
                return;
            }

            this.$el.find('.project-search-launcher').removeClass('active');
        },

        onCloseOnboardingAssistant: function(e) {
            this.$el.find('.onboarding-overlay').remove();
            this.$el.find('.onboarding-assistant').remove();
            this.$el.find('.create-project').removeClass('create-project-onboarding');
        }
    },

    initialize: function() {
        var project_type = Router.getQueryString('t');
        if (['feedback', 'survey', 'archived'].includes(project_type)) {
            this.project_type = project_type;
        }

        this.listenTo(Cache.project,        'add',                this.render);
        this.listenTo(Cache.project,        'remove',             this.sortProjects);
        this.listenTo(Cache.project,        'change:is_archived', this.sortProjects);

        // TODO: binding this.render is too "lazy"
        this.listenTo(Cache.project_domain, 'add',                this.render);
        this.listenTo(Cache.project_domain, 'remove',             this.render);
        this.listenTo(Cache.project_domain, 'change',             this.render);

        this.on('remove', () => {
            $(document).off('click.project_search');
        });

        if (!this.isLoaded()) {
            this.listenTo(Cache.statistics, 'change:project_count', this.render);
        }
    },

    confirmEmail: function(email_code) {
        // email address confirmation
        if (Cache.getRealUser().get('is_email_confirmed')) {
            UI.success('Your email address has been verified');
        } else {
            Cache.app.request({
                action: 'user/confirmEmail',
                data : {
                    key: email_code
                },
                success: function(response) {
                    UI.success('Your email address has been verified');
                    Cache.getRealUser().set('is_email_confirmed', true);
                }
            });
        }
    },

    isLoaded() {
        return Cache.statistics.get('project_count') ? true : false;
    },

    onPageReady: function() {
        var query_string = Router.getQueryString();

        if (!Cache.project.where({is_archived: true}).length) {
            this.$el.find('.archived-container').hide();
        }

        if (query_string.notification == 1) {
            Modals.editUserNotification(Cache.real_user_id);
        }

        $(document).on('click.project_search', this.dom_handlers.onDocumentClick.bind(this));

        if (query_string.ec) {
            // email address confirmation
            this.confirmEmail(query_string.ec);
        } else if (query_string.upgrade == 1) {
            Modals.choosePlan();
        } else if (query_string.upgrade == 2) {
            Modals.choosePlan(undefined, undefined, true);
        } else if (query_string.upgrade == 3) {
            Modals.choosePlan(undefined, undefined, false, true);
        } else if (query_string.upgrade == 4) {
            Modals.choosePlan(undefined, undefined, false, false, true);
        }

        // account onboarding
        if (Cache.account.displayOnboarding()) {
            Modals.onboarding();
        }

        // project sort needs project_count to be loaded
        if (!Cache.statistics.get('project_count') && !Cache.statistics.is_loading) {
            Cache.statistics.syncProjectCount();
        }
    },

    renderProjectOverview: function(view, domain) {
        if (Cache.project.group_by === 'domain') {
            view.render().$el.appendTo(this.$el.find('.region-domain[data-domain="' + domain + '"]'));
        } else {
            view.render().$el.appendTo(this.$el.find('.region-active'));
        }
    },

    searchProjects: function() {
        var count = 0;

        _.each(this.views.project_overview, (project_view) => {
            var show = false;

            if (project_view.model.get('name').toLowerCase().indexOf(this.search_value) !== -1) {
                show = true;
                count++;
            }

            project_view.toggle(show);
        });

        if (Cache.project.group_by === 'domain') {
            this.$el.find('.region-domain').each((index, el) => {
                $(el).attr('data-match', $(el).find('.project-overview').not('[data-hidden]').length);
            });
        }

        this.$el.find('.survey-coming-soon').hide();
        this.$el.find('.project-container .search-result-empty').toggle(count === 0);

        if (!Cache.account.hasFeature('survey') && this.project_type === 'survey') {
            this.$el.find('.project-container .search-result-empty').hide();
            this.$el.find('.survey-coming-soon').show();
        }
    },

    // sort and render projects
    sortProjects: function(e) {
        if (!this.isLoaded()) {
            return;
        }

        Cache.project.sort();

        this.removeChildViews();

        // create new views
        if (Cache.project.group_by === 'domain') {
            this.getGroupByDomains().forEach((domain) => {
                var project_ids = [];

                if (domain === 'No domains') {
                    this.getNoDomainProjects().forEach((project_model) => {
                        project_ids.push(project_model.id);
                    });
                } else {
                    var domains = Cache.project_domain.where({domain: domain});
                    domains.forEach((domain_model) => {
                        project_ids.push(domain_model.get('project_id'));
                    });
                }

                // project_ids is not sorted because it is from the project_domain collection
                // sort it in using its order in the project collection
                project_ids.sort((a, b) => {
                    var index_a = Cache.project.indexOf(Cache.project.get(a));
                    var index_b = Cache.project.indexOf(Cache.project.get(b));

                    if (index_a < index_b) {
                        return -1;
                    } else if (index_a > index_b) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                project_ids.forEach((project_id) => {
                    var project_model = Cache.project.get(project_id);

                    if (!project_model) {
                        return;
                    }

                    switch (this.project_type) {
                        case 'active':
                            if (project_model.get('is_archived')) {
                                return;
                            }
                            break;
                        case 'feedback':
                            if (!project_model.isFeedback() || project_model.get('is_archived')) {
                                return;
                            }
                            break;
                        case 'survey':
                            if (!project_model.isSurvey() || project_model.get('is_archived')) {
                                return;
                            }
                            break;
                        case 'archived':
                            if (!project_model.get('is_archived')) {
                                return;
                            }
                            break;
                    }

                    this.views.project_overview[domain + '_' + project_model.id] = new View_Project_Overview({model: project_model});
                });
            });
        } else {
            switch (this.project_type) {
                case 'active':
                    Cache.project.where({is_archived: false}).forEach((model) => {
                        this.views.project_overview['_' + model.id] = new View_Project_Overview({model: model});
                    });
                    break;
                case 'feedback':
                    Cache.project.where({is_archived: false}).forEach((model) => {
                        if (model.isFeedback()) {
                            this.views.project_overview['_' + model.id] = new View_Project_Overview({model: model});
                        }
                    });
                    break;
                case 'survey':
                    Cache.project.where({is_archived: false}).forEach((model) => {
                        if (model.isSurvey()) {
                            this.views.project_overview['_' + model.id] = new View_Project_Overview({model: model});
                        }
                    });
                    break;
                case 'archived':
                    Cache.project.where({is_archived: true}).forEach((model) => {
                        this.views.project_overview['_' + model.id] = new View_Project_Overview({model: model});
                    });
                    break;
            }
        }

        _.each(this.views.project_overview, (project_view, key) => {
            var domain = key.replace('_' + project_view.model.id, '');
            this.renderProjectOverview(project_view, domain);
        });

        this.renderCount();
    },

    getNoDomainProjects: function() {
        var projects = [];

        Cache.project.each((model) => {
            if (Cache.project_domain.where({project_id: model.id}).length === 0) {
                projects.push(model);
            }
        });

        return projects;
    },

    getGroupByDomains: function() {
        var project_domains = [];

        Cache.project_domain.each((model) => {
            if (project_domains.indexOf(model.escape('domain')) === -1) {
                project_domains.push(model.escape('domain'));
            }
        });

        project_domains.push('No domains');

        return project_domains;
    },

    removeChildViews: function() {
        _.each(this.views.project_overview, (project_view) => {
            project_view.remove();
        });

        this.views.project_overview = {};
    },

    renderCount: function() {
        var active_total = Cache.project.where({is_archived: false}).length;
        var archived_total = Cache.project.where({is_archived: true}).length;
        var survey_total = Cache.project.where({is_archived: false, project_type: 'survey'}).length;

        this.$el.find('.project-menu[data-val="active"] .project-count').text(active_total);
        this.$el.find('.project-menu[data-val="feedback"] .project-count').text(active_total - survey_total);
        this.$el.find('.project-menu[data-val="survey"] .project-count').text(survey_total);
        this.$el.find('.project-menu[data-val="archived"] .project-count').text(archived_total);
    },

    renderSortBy: function() {
        var button_text = {
            updated : 'Date updated',
            created : 'Date created',
            name    : 'Name'
        };

        // button text
        this.$el.find('.dropdown-project-sort > button').text(button_text[Cache.project.sort_by]);

        // sort by
        this.$el.find('.project-sort-by').removeClass('selected');
        this.$el.find('.project-sort-by[data-val="' + Cache.project.sort_by + '"]').addClass('selected');

        // sort order
        this.$el.find('.project-sort-order').removeClass('selected');
        this.$el.find('.project-sort-order[data-val="' + Cache.project.sort_order + '"]').addClass('selected');

        // group by
        this.$el.find('.project-group-by').removeClass('selected');
        this.$el.find('.project-group-by[data-val="' + Cache.project.group_by + '"]').addClass('selected');
    },

    render: function() {
        UI.setPageTitle('Projects');

        var project_onboarding = !Cache.account.hasFeature('survey') && !Cache.account.displayOnboarding() && Cache.app.isAdmin() && Router.getQueryString('onboarding');

        var first_name = Cache.getRealUser().get('name').split(' ')[0];

        var active_total = Cache.project.where({is_archived: false}).length;
        var archived_total = Cache.project.where({is_archived: true}).length;
        var survey_total = Cache.project.where({is_archived: false, project_type: 'survey'}).length;

        var domain_options  = '';
        this.getGroupByDomains().forEach((domain) => {
            domain_options += '<div class="region-domain active" data-domain="' + domain + '"></div>';
        });

        var content =
        '<main class="xlarge">' +
            '<div class="project-header">' +
                '<h1>Projects</h1>' +
                (project_onboarding ?
                '<div class="onboarding-overlay"></div>' +
                '<div class="onboarding-assistant">' +
                    '<button class="close" type="button"><i class="fa-regular fa-xmark"></i></button>' +
                    '<img src="/image/assistant_profile.png">' +
                    '<div>Howdy ' + Util.htmlEntities(first_name) + '! Welcome to Userback 👋. Click the button to create a new project.</div>' +
                '</div>' : '') +

                (Cache.app.isAdmin() ?
                '<button type="button" class="primary medium min inline create-project' + (project_onboarding ? ' create-project-onboarding' : '') + '"><i class="far fa-plus margin-right-8"></i>Create</button>' : '') +
            '</div>' +

            '<div class="tab">' +
                '<div class="tab-menu">' +
                    '<div class="project-search-launcher">' +
                        '<input type="text" placeholder="Search projects...">' +
                    '</div>' +

                    '<a href="#" class="project-menu" data-val="active">' +
                        '<span class="flex-c">' +
                            '<span>All</span>' +
                            '<span class="project-count badge-secondary-invert badge-small badge-round badge-fluid selectable font-weight-semibold margin-left-8">' + active_total + '</span>' +
                        '</span>' +
                    '</a>' +

                    '<a href="#" class="project-menu" data-val="feedback">' +
                        '<span class="flex-c">' +
                            '<span>Feedback</span>' +
                            '<span class="project-count badge-secondary-invert badge-small badge-round badge-fluid selectable font-weight-semibold margin-left-8">' + (active_total - survey_total) + '</span>' +
                        '</span>' +
                    '</a>' +

                    '<a href="#" class="project-menu" data-val="survey">' +
                        '<span class="flex-c">' +
                            '<span>Survey</span>' +
                            '<span class="project-count badge-secondary-invert badge-small badge-round badge-fluid selectable font-weight-semibold margin-left-8">' + survey_total + '</span>' +
                        '</span>' +
                    '</a>' +

                    (Cache.app.isClient() ? '' :
                    '<a href="#" class="project-menu mobile-hidden" data-val="archived">' +
                        '<span class="flex-c">' +
                            '<span>Archived</span>' +
                            '<span class="project-count badge-secondary-invert badge-small badge-round badge-fluid selectable font-weight-semibold margin-left-8">' + archived_total + '</span>' +
                        '</span>' +
                    '</a>') +

                    '<div class="button-dropdown dropdown-project-sort" data-append="true">' +
                        '<button type="button" class="dropdown-select dropdown-select-small dropdown-select-text-invert font-weight-medium"></button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select">' +
                                '<li class="dropdown-title">Sort by</li>' +
                                '<li class="project-sort-by" data-val="updated">Date updated</li>' +
                                '<li class="project-sort-by" data-val="created">Date created</li>' +
                                '<li class="project-sort-by" data-val="name">Name</li>' +

                                '<li class="separator"></li>' +

                                '<li class="dropdown-title">Order</li>' +
                                '<li class="project-sort-order" data-val="desc">Newest first</li>' +
                                '<li class="project-sort-order" data-val="asc">Oldest first</li>' +

                                '<li class="separator"></li>' +
                                '<li class="project-group-by" data-val="domain">Group by domain</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            (Cache.project.length ?

            '<div class="project-container">' +
                '<div class="archived-delete-banner margin-bottom-16 text-info">Projects will be deleted 12 months after they are archived.</div>' +
                (Cache.project.group_by === 'domain' ? domain_options : '') +

                (this.isLoaded() ?
                '<div class="region-active"></div>' +
                '<div class="search-result-empty search-result-empty-large">' +
                    '<div class="text-regular">No projects found</div>' +
                '</div>' +
                (Cache.account.hasFeature('survey') ? '' :
                '<div class="survey-coming-soon box text-align-center" style="display:none;">' +
                    '<img src="/image/survey_hero.png" width="360">' +
                    '<div style="max-width:540px;margin:auto;">' +
                        '<h2 class="margin-top-24 margin-bottom-12 font-weight-semibold">This feature is not available on your current plan</h2>' +
                        '<p class="margin-bottom-24 line-height-150">Upgrade your plan to unlock the power of <span class="font-weight-medium">Net Promoter Score®</span>, <span class="font-weight-medium">Customer Satisfaction</span>, and <span class="font-weight-medium">more</span> to help you understand user behavior and sentiment.</p>' +
                        '<button + type="button" class="account-upgrade medium shiny tertiary"><span>Upgrade my plan</span></button>' +
                    '</div>' +
                '</div>') :
                '<div class="loader-placeholder-medium"></div>' +
                '<div class="loader-placeholder-medium margin-top-16"></div>' +
                '<div class="loader-placeholder-medium margin-top-16"></div>') +
            '</div>' :

            // empty state: user has access to 0 projects
            '<div class="search-result-empty search-result-empty-large active">' +
                (Cache.app.isAdmin() ?
                '<div>Click <a href="#" class="create-project primary">+ Create</a> button to create your first project</div>' :
                '<div>You do not have access to any projects in this workspace. Please contact your administrator.</div>') +
            '</div>') +

        '</main>';

        this.removeChildViews();

        this.$el.html(content);

        this.$el.find('.project-menu[data-val="' + this.project_type + '"]').addClass('active');
        this.$el.find('.archived-delete-banner').toggle(this.project_type === 'archived');

        this.renderCount();
        this.renderSortBy();
        this.sortProjects();
        this.searchProjects();

        return this;
    }
});